<template>
  <div class="bgfixed">
    <div class="bgblue"></div>
    <div class="content"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>
<style lang="less" scoped>
.bgfixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
}
.bgblue {
  // background: #6d90e2;
  height: 20px;
}
.content {
  margin-top: -15px;
  border-radius: 16px 16px 0 0;
  padding: 0 15px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/header_bg.vue